import {
  ApiBlueprint,
  ApiRef,
  BackstageIdentityApi,
  configApiRef,
  createApiRef,
  discoveryApiRef,
  oauthRequestApiRef,
  OpenIdConnectApi,
  ProfileInfoApi,
  SessionApi,
} from "@backstage/frontend-plugin-api";
import { OAuth2 } from "@backstage/core-app-api";

export const auth0AuthApiRef: ApiRef<
  OpenIdConnectApi & ProfileInfoApi & BackstageIdentityApi & SessionApi
> = createApiRef({
  id: "core.auth.auth0",
});

export const auth0Api = ApiBlueprint.make({
  params: (defineParams) =>
    defineParams({
      api: auth0AuthApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        oauthRequestApi: oauthRequestApiRef,
        configApi: configApiRef,
      },
      factory: ({ discoveryApi, oauthRequestApi, configApi }) => {
        return OAuth2.create({
          configApi,
          discoveryApi,
          oauthRequestApi,
          provider: {
            id: "auth0",
            title: "Auth0",
            icon: () => null,
          },
          defaultScopes: ["openid", "email", "profile"],
        });
      },
    }),
});

export const apis = [
  auth0Api,
];
